<template>
  <section
    :class="[
      'surface-50 flex align-items-center justify-content-center px-3 md:px-5 w-full',
      compact ? 'py-5' : 'py-8',
    ]"
    :role="live ? 'status' : undefined"
    :aria-live="live ? 'polite' : undefined"
    :aria-atomic="live ? 'true' : undefined"
  >
    <div
      class="flex flex-column align-items-center justify-content-center text-center p-4 md:p-5 w-full"
    >
      <Avatar
        :icon="icon"
        shape="circle"
        size="xlarge"
        class="surface-100 text-primary mb-3"
      />

      <component :is="headingTag" class="text-900 text-2xl md:text-3xl font-bold m-0">
        {{ title }}
      </component>

      <p class="text-600 line-height-3 max-w-30rem mt-2 mb-0">{{ description }}</p>

      <div
        v-if="$slots.actions"
        class="flex flex-column sm:flex-row justify-content-center gap-2 mt-4 w-full sm:w-auto"
      >
        <slot name="actions" />
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  eyebrow: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: 'pi pi-inbox',
  },
  headingTag: {
    type: String,
    default: 'h2',
  },
  compact: {
    type: Boolean,
    default: false,
  },
  live: {
    type: Boolean,
    default: false,
  },
})
</script>
